import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.polyfills.min';
import Rellax from 'rellax';

export function scrolEvents(controller , scene){

  if(document.getElementsByClassName('rellax').length > 0){
      const rellax = new Rellax('.rellax',{
          center:true
      });
  }
  if(document.getElementsByClassName('rellax-no').length > 0){
      const rellax_no = new Rellax('.rellax-no',{
          center:false
      });
  }

    const scroll = new SmoothScroll('a[href*="#"], [data-scroll]',{
    offset: 0,
		speed: 1000,
		easing: 'easeInOutQuart',
		speedAsDuration: true,
		durationMin: 1000
    });
	
}